// Free-shipping threshold for markets whose currency has no hand-set amount (everything but PLN and
// EUR, see snippets/free-shipping-threshold.liquid). The base amount is the Polish threshold in the
// shop currency; Shopify exposes the market's exchange rate to the browser as Shopify.currency.rate
// (not to Liquid), so the conversion happens here. Shared by the announcement bar and the cart card
// so both always show the same number.
window.CowalkiesFreeShipping = window.CowalkiesFreeShipping || {
  rate: function () {
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return rate > 0 ? rate : 1;
  },

  // Whole units, rounded up to a tidy multiple of 5 once the number is big enough to look odd
  // otherwise (608.2 -> 610), so the shopper sees "610 kr", never "608,17 kr".
  convert: function (baseUnits) {
    var value = baseUnits * this.rate();
    var step = value >= 50 ? 5 : 1;
    return Math.max(step, Math.ceil(value / step) * step);
  },

  // PLN and EUR follow the same conventions as snippets/shipping-money.liquid ("350 zł", "€80" /
  // "80 €" from the localized pattern); any other currency is formatted by the browser.
  format: function (units, currency, pattern) {
    if (currency === 'PLN') return units + ' zł';
    if (currency === 'EUR' && pattern) return pattern.replace('[symbol]', '€').replace('[amount]', units);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(units);
    } catch (e) {
      return units + ' ' + currency;
    }
  },

  // "text [amount] text" -> nodes with the amount in a <strong> (or plain when strong is false).
  fill: function (template, amountText, strong) {
    var parts = String(template).split('[amount]');
    var fragment = document.createDocumentFragment();
    parts.forEach(function (part, index) {
      if (index > 0) {
        var amount = strong ? document.createElement('strong') : document.createDocumentFragment();
        amount.appendChild(document.createTextNode(amountText));
        fragment.appendChild(amount);
      }
      fragment.appendChild(document.createTextNode(part));
    });
    return fragment;
  },

  // Announcement bar: fills the template text and reveals it.
  fillBar: function (element) {
    var amount = this.format(this.convert(parseFloat(element.dataset.fsBase)), element.dataset.fsCurrency);
    element.textContent = '';
    element.appendChild(this.fill(element.dataset.fsTemplate, amount, false));
    element.style.visibility = 'visible';
  },

  // Threshold in whole units of the cart currency: used as-is for PLN/EUR, converted for the rest.
  thresholdUnits: function (root) {
    var amount = parseFloat(root.dataset.fsAmount);
    return root.dataset.fsMode === 'convert' ? this.convert(amount) : amount;
  },

  // One line, always: start from the configured size and step down (to a floor) until it fits.
  fit: function (text) {
    if (!text._fsSize) text._fsSize = parseFloat(getComputedStyle(text).fontSize);
    var size = text._fsSize;
    text.style.fontSize = size + 'px';
    while (size > 11 && text.scrollWidth > text.clientWidth + 1) {
      size -= 0.5;
      text.style.fontSize = size + 'px';
    }
  },

  // Announcement bar. No cart: "Free shipping on orders over X". Items in the cart: "You're X away
  // from free shipping" with the bar filled to the share reached.
  renderBar: function (root) {
    var self = this;
    var text = root.querySelector('[data-fs-text]');
    var currency = root.dataset.fsCurrency;
    var pattern = root.dataset.fsPattern;
    var threshold = this.thresholdUnits(root);
    var total = (parseFloat(root.dataset.fsTotal) || 0) / 100;
    var hasItems = parseInt(root.dataset.fsCount, 10) > 0;
    var progress = 0;
    var node;

    if (!hasItems) {
      node = this.fill(root.dataset.fsTplOver, this.format(threshold, currency, pattern), false);
    } else if (total >= threshold) {
      progress = 100;
      node = this.fill(root.dataset.fsTplFree, '', false);
    } else {
      progress = Math.round((total / threshold) * 1000) / 10;
      node = this.fill(root.dataset.fsTplMore, this.format(Math.ceil(threshold - total), currency, pattern), true);
    }

    text.textContent = '';
    text.appendChild(node);
    text.style.visibility = 'visible';
    root.style.setProperty('--fs-progress', progress + '%');
    this.fit(text);
    if (!root._fsFitBound) {
      root._fsFitBound = true;
      window.addEventListener('resize', function () {
        self.fit(text);
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          self.fit(text);
        });
      }
    }
  },

  syncBar: function (root) {
    var self = this;
    fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', { cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        root.dataset.fsTotal = cart.total_price;
        root.dataset.fsCount = cart.item_count;
        self.renderBar(root);
      })
      .catch(function () {});
  },

  initBar: function (root) {
    var self = this;
    if (!root) return;
    this.renderBar(root);
    // pubsub.js is deferred, so subscribe once the document is parsed.
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          self.syncBar(root);
        });
      }
    });
    // Back/forward cache restores an old page: re-read the cart.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) self.syncBar(root);
    });
  },
};
